import { fetchAssigneeList } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/assignees';

const mapDispatchToProps = {
	fetchAssigneeList,
};

export default mapDispatchToProps;
